import React, { useCallback, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ActionPrintSalesOrder from '../ActionPrintSalesOrder';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  salesOrderId: string | number;
}

const ModalAskPrintSalesOrder: React.FC<Props> = ({isOpen, onClose, salesOrderId}) => {
  const {t} = useTranslation();

  const handleOnClose = useCallback(() => {
    onClose();
  }, []);

  return (
    <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
      <Modal.Header closeButton>
        <Modal.Title>Print Sales Order</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          Are you want to print receipts sales order?
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant={'light'} onClick={onClose}>
          {t('Cancel')}
        </Button>
        <ActionPrintSalesOrder salesOrderId={salesOrderId} />
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAskPrintSalesOrder;